import { render, staticRenderFns } from "./template_add.vue?vue&type=template&id=17c3b827&"
import script from "./template_add.vue?vue&type=script&lang=js&"
export * from "./template_add.vue?vue&type=script&lang=js&"
import style0 from "./template_add.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports